let button;
let slidePath = [];
let prevSlide = null;
let returning = false;

function addBackButton() {
    button = document.createElement('div');
    button.classList.add('back-button');
    button.classList.add('hidden');
    !Q3.editMode && Q3.container.parentElement.appendChild(button);

    Q3.Events.listen('leaveslide', ({ slideIndex: index }) => prevSlide = index);
    Q3.Events.listen('enterslide', setSlide);

    button.addEventListener('click', e => {
        returning = true;
        let index = slidePath[slidePath.length-1];
        Q3.SlideManager.setSlide(index);
        returning = false;
    });

    if (Q3.editMode) {
        button.style.pointerEvents = 'none';
    }
}

function setSlide(nextSlide) {
    let nextSlideData = Q3.data.slides[nextSlide];
    let nextHidden = nextSlideData && !nextSlideData.visible;

    if (nextHidden) {
        if (returning) {
            slidePath.length--;
        } else {
            button.classList.remove('hidden');
            slidePath.push(prevSlide);
        }
    } else {
        button.classList.add('hidden');
        slidePath.length = 0;
    }
}

export default addBackButton;
